export default {
      id: "huge-pen2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-pen2",
      toString: function () {
        return this.url;
      }
    }